'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { useStockQuantity } from '@/src/lib/stock-quantity/hooks/use-stock-quantity.ts';
import Loading from '@/src/app/components/LoadingSpinner/LoadingSpinner.tsx';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { handleException } from '@/src/lib/core/exception/handle-exception.ts';
import { getStockQuantityValueFromResponse } from '@/src/lib/stock-quantity/business/stock-quantity.ts';
function StockQuantity(t0) {
  const $ = _c(11);
  const {
    sku,
    dict
  } = t0;
  const {
    mutate,
    isPending,
    isError,
    error,
    data
  } = useStockQuantity(sku);
  let t1;
  if ($[0] !== mutate || $[1] !== sku) {
    t1 = () => {
      mutate([sku]);
    };
    $[0] = mutate;
    $[1] = sku;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (isPending) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="h-4 float-right"><Loading small={true} /></div>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (isError) {
    handleException(error);
    let t3;
    if ($[5] !== dict.product.stockQuantityError) {
      t3 = <span className="text-danger">{dict.product.stockQuantityError}</span>;
      $[5] = dict.product.stockQuantityError;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (data) {
    let t3;
    if ($[7] !== data) {
      t3 = getStockQuantityValueFromResponse(data);
      $[7] = data;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t3) {
      t4 = <>{t3}</>;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  return null;
}
export default StockQuantity;